import api from '../../../services/api';

export const CompaniesHTTP = {
  myCompany: () => api.get('/my-company'),
  updateMyCompany: (payload = {}) => api.put('/my-company', payload),
};
